import { render, staticRenderFns } from "./responseType.vue?vue&type=template&id=3ecae8ab&"
import script from "./responseType.vue?vue&type=script&lang=js&"
export * from "./responseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports